export enum ResourceEnum {
    EVENTS = 'events',
    TRIPS = 'trips',
}
